import { OP_LOGISTIC, PORT1 } from "../../api/config/servicePort"
import UtilOp from "../../services/serviceOp"
const utilOp = UtilOp.getInstance()

//登录
export const userLogin = (params) => {
  return utilOp.httpPost(`${PORT1}/auth/login`, params)
}
